// Pipelines that carry service-request tickets ("solicitudes"). Mirrors the
// backend rule in core/pipeline/service.ts — only these two get
// ticketPositions seeded on creation, so only they have a ticket board.
export const TICKET_PIPELINE_IDS: ReadonlySet<string> = new Set(["general", "maintenance"]);

export const hasTickets = (pipelineId: string): boolean => TICKET_PIPELINE_IDS.has(pipelineId);
